var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.isProcessing,"timeout":-1,"color":"info","bottom":"","app":"","multi-line":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('v-progress-circular',{staticClass:"mr-3",attrs:{"indeterminate":"","size":"20","width":"2"}}),_vm._v(" Compression de la photo en cours... ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }